// React
import { useEffect } from 'react';
import { tap, interval } from 'rxjs';

// Internal
import { triggerRedraw } from './triggers';

/**
 * @param {!BrickContext} $
 */
export function initScroll($) {
    // Auto-redraw on scroll (fix fast scrolling issue)
    $.set('_rgLastScroll', 0);
    $.set('_rgLastScrollRedraw', 0);
    interval(1000)
        .pipe(tap(() => {
            if($.get('_rgLastScroll') !== $.get('_rgLastScrollRedraw')) {
                $.set('_rgLastScrollRedraw', $.get('_rgLastScroll'));
                triggerRedraw($);
            }
        }))
        .subscribe();
}

/**
 * @param {!BrickContext} $
 * @param {!*} ref
 */
export function useRedrawAfterScroll($, ref) {
    const registerScroll = () => $.set('_rgLastScroll', Date.now());
    useEffect(() => {
        if (ref.current) {
            ref.current.parentElement.style.overflow = 'visible';
            ref.current.addEventListener('scroll', registerScroll);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener('scroll', registerScroll);
            }
        };
    }, [ref]);
}

